module.exports = __webpack_public_path__ + "img/cases-brand-hla-8.f305334e.png";